module.exports = __webpack_public_path__ + "img/res008.85061e1a.png";